export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE'
}

export const BACKEND_DATE_FORMAT = 'MM/DD/yyyy HH:mm:ss';
